var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chart',{attrs:{"forceFit":true,"height":_vm.height,"data":_vm.data,"scale":_vm.scale,"padding":"auto"}},[_c('v-tooltip'),_c('v-axis'),_c('v-line',{attrs:{"position":"year*value"}}),_c('v-point',{attrs:{"position":"year*value","shape":"circle"}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vue/cli-service/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571572f3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/@vue/cli-service/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/charts/chart-temperature.vue
// module id = null
// module chunks = 